import { createContext, useContext } from 'react'

export type ToastTone = 'neutral' | 'success' | 'error'

export interface Toast {
  id: number
  message: string
  tone: ToastTone
  /** Milliseconds before auto-dismiss; 0 keeps it until dismissed by hand. */
  duration: number
}

export interface ToastOptions {
  tone?: ToastTone
  duration?: number
}

export interface ToastApi {
  show: (message: string, options?: ToastOptions) => number
  success: (message: string, options?: ToastOptions) => number
  error: (message: string, options?: ToastOptions) => number
  dismiss: (id: number) => void
}

/** Lives in hooks/ so <ToastProvider> stays a component-only module. */
export const ToastContext = createContext<ToastApi | null>(null)

export function useToast(): ToastApi {
  const api = useContext(ToastContext)
  if (!api) throw new Error('useToast() used outside <ToastProvider>')
  return api
}
